import React from 'react';

interface RocOptionsTableTitleProps {
	children: React.ReactNode;
}

/**
 * Placeholder component to display the title for simple listing tables @see RocOptionsTable
 */
export default function RocOptionsTableTitle(props: RocOptionsTableTitleProps) {
	const { children, ...rest } = props;

	return (
		<h3 className="roc-options-table__title" {...rest}>
			{children}
		</h3>
	);
}
